"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const selector = Symbol('selector');
const property = Symbol('property');
const prefix = Symbol('prefix');
const suffix = Symbol('suffix');
const array = Symbol('array');
const name = Symbol('name');
exports.default = {
    selector,
    prefix,
    suffix,
    name,
    array,
    property,
    [selector]: (prefix, suffixes) => {
        return { type: 'selector', prefix, suffixes };
    },
    [name]: (token, wildcard) => {
        return { type: 'name', token, wildcard };
    },
    [array]: (start, slice, end, single) => {
        return { type: 'array', start, slice, end, single };
    },
    [property]: (name) => {
        return { type: 'property', name };
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9kZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbm9kZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxNQUFNLFFBQVEsR0FBRyxNQUFNLENBQUMsVUFBVSxDQUFDLENBQUE7QUFDbkMsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQyxDQUFBO0FBQ25DLE1BQU0sTUFBTSxHQUFLLE1BQU0sQ0FBQyxRQUFRLENBQUMsQ0FBQTtBQUNqQyxNQUFNLE1BQU0sR0FBSyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUE7QUFDakMsTUFBTSxLQUFLLEdBQU0sTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFBO0FBQ2hDLE1BQU0sSUFBSSxHQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQU8vQixrQkFBZTtJQUNiLFFBQVE7SUFDUixNQUFNO0lBQ04sTUFBTTtJQUNOLElBQUk7SUFDSixLQUFLO0lBQ0wsUUFBUTtJQUVSLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxNQUFNLEVBQUUsUUFBUSxFQUFRLEVBQUU7UUFDckMsT0FBTyxFQUFFLElBQUksRUFBRSxVQUFVLEVBQUUsTUFBTSxFQUFFLFFBQVEsRUFBRSxDQUFBO0lBQy9DLENBQUM7SUFDRCxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsS0FBSyxFQUFFLFFBQVEsRUFBUSxFQUFFO1FBQ2hDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUUsQ0FBQTtJQUMxQyxDQUFDO0lBQ0QsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsR0FBRyxFQUFFLE1BQU0sRUFBUSxFQUFFO1FBQzNDLE9BQU8sRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsR0FBRyxFQUFFLE1BQU0sRUFBRSxDQUFBO0lBQ3JELENBQUM7SUFDRCxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUMsSUFBSSxFQUFRLEVBQUU7UUFDekIsT0FBTyxFQUFFLElBQUksRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQUE7SUFDbkMsQ0FBQztDQUNGLENBQUEifQ==